var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何分配权限给成员")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“企业控制台”进入企业管理界面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img7.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "2.点击“成员管理”，进入成员管理页面，点击在组织及成员菜单下，找到需要赋予权限的成员，点击分配权限"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img8.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "3.勾选想要赋予成员的权限组（系统默认提供三个权限组，可按需定制，在权限组页面创建），点击确定。"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img9.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84f68668", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f68668","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/3_permsToMenber.vue
// module id = OhYt
// module chunks = 54 240